module.exports = __webpack_public_path__ + "img/brand(6).f4b21281.png";